import { render, staticRenderFns } from "./yzImageUpload.vue?vue&type=template&id=c44c64e4&scoped=true&"
import script from "./yzImageUpload.vue?vue&type=script&lang=js&"
export * from "./yzImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./yzImageUpload.vue?vue&type=style&index=0&id=c44c64e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44c64e4",
  null
  
)

export default component.exports